import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";

export default function InsightDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useSEO({
    title: post ? `${post.title} | EnPrex Insights` : "EnPrex Insights",
    description: post?.excerpt || "Practitioner insights on energy and commodity trading technology.",
    path: `/insights/${slug || ""}`,
    image: post?.cover_image,
  });

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);  if (notFound) {
    return (
      <div className="container-x py-32 text-center" data-testid="post-not-found">
        <h1 className="font-display text-4xl text-white">Article not found</h1>
        <Link to="/insights" className="mt-6 inline-block text-[#D4AF37] underline">← Back to insights</Link>
      </div>
    );
  }

  if (!post) return <div className="container-x py-32 text-slate-400 font-mono text-sm">Loading…</div>;

  return (
    <article data-testid="post-detail" className="container-x pt-16 pb-24 max-w-4xl mx-auto">
      <Link to="/insights" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-slate-400 hover:text-[#D4AF37] font-mono mb-8">
        <ArrowLeft size={14} /> Back to insights
      </Link>
      <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-slate-400 mb-6">
        <span className="text-[#D4AF37]">{post.category}</span>
        <span className="w-8 h-px bg-slate-600" />
        <span>{post.read_time}</span>
      </div>
      <h1 className="font-display text-4xl md:text-6xl font-light text-white tracking-tighter leading-[1.05]">
        {post.title}
      </h1>
      <div className="mt-8 flex items-center gap-3 text-sm text-slate-300 pb-8 border-b border-white/5">
        <span className="font-medium">{post.author}</span>
        <span className="w-4 h-px bg-slate-600" />
        <span className="font-mono text-xs">{new Date(post.published_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</span>
      </div>

      {post.cover_image && (
        <div className="aspect-[16/9] overflow-hidden my-12">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      )}

      <div className="prose-invert max-w-none space-y-6 text-lg text-slate-300 leading-relaxed font-light">
        {post.content.split("\n\n").map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>

      <div className="mt-16 pt-8 border-t border-white/5">
        <Link to="/contact" className="inline-flex items-center gap-3 bg-[#D4AF37] text-[#050A14] px-8 py-4 text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#FDE047] transition-colors">
          Discuss this with our team →
        </Link>
      </div>
    </article>
  );
}
